export const TEST_ID = 'woocommerce-integration';
export const APPCUES_ID = 'woocommerce-slot';
export const SLOT_TITLE = 'Woocommerce';
export const MODAL_TITLE = 'Woocommerce';
export const MODAL_SUBTITLE_INITIAL = 'Learn how to find your credentials ';
export const MODAL_SUBTITLE_FINAL = 'here';
export const API_TOKEN_LINK = 'https://docs.woocommerce.com/document/woocommerce-rest-api/';

export const API_GET_DATA_URL = '/api/integration/woocommerce';
export const API_INTEGRATE_URL = '/api/integration/woocommerce';
export const API_SUCCESS_OP_MESSAGE = 'Api Token Successfully Saved.';
export const API_FAIL_DEFAULT_OP_MESSAGE = 'Unknown Error';

export const FIELDS = {
    STORE_URL: {
        LABEL: 'Store Url',
        NAME: 'storeUrl',
        PLACEHOLDER: 'mystore.com',
        TEST_ID: 'woocommerce-modal-input-store',
    },
    CONSUMER_KEY: {
        LABEL: 'Consumer Key',
        NAME: 'consumerKey',
        PLACEHOLDER: 'ck_123456789',
        TEST_ID: 'woocommerce-modal-input-key',
    },
    CONSUMER_SECRET: {
        LABEL: 'Consumer Secret',
        NAME: 'consumerSecret',
        PLACEHOLDER: 'cs_123456789',
        TEST_ID: 'woocommerce-modal-input-secret',
    },
};
